import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/component/core/App';
import registerServiceWorker from './js/lib/registerServiceWorker';

const startApp = () => {
  ReactDOM.render(<App />, document.getElementById('root'));
};
startApp();
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js